module.exports = __webpack_public_path__ + "static/media/alis30.633bc1dd.jpg";